import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAzh7C_Q3ONx-CJG4PKyZ-REHLnc4gE3NA",
  authDomain: "besor3a-c04d4.firebaseapp.com",
  projectId: "besor3a-c04d4",
  storageBucket: "besor3a-c04d4.firebasestorage.app",
  messagingSenderId: "8061694556",
  appId: "1:8061694556:web:9a349989fe3877da712c99"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFCMToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: 'BGsIjRTZ-6oFZjniBO1sc4XwAJxswT71pR6j-41C5xqHioRJxgoJvteje3U0r_iiewPE1wClpd5XFa7GHvmIYlI'
    });
    return token;
  } catch(err) {
    console.error('FCM token error:', err);
    return null;
  }
};

export const onForegroundMessage = (callback) => {
  onMessage(messaging, callback);
};
